<!-- @format -->

<accept-modal>
  <div
    class="modal js-modal"
    is="modal-base"
    status="{ props.status }"
    on-before-show="{ onBeforeShow }"
  >
    <div class="modal__bg js-modal-close"></div>
    <div class="modal__content modal_filter">
      <div class="modal__content_inner">
        <h2 class="modal_title">履歴の検索条件を絞り込む</h2>
        <p class="notice align-r">
          ※未入力の項目は「指定なし」として扱います。
        </p>

        <form class="form_filter">
          <h3 class="modal_subtitle">解析実行期間</h3>
          <div class="modal_input_container">
            <div class="modal_input_box">
              <label for="day_start">開始日</label>
              <input
                type="text"
                id="day_start"
                name="start_date"
                data="{ state.data }"
                is="binding"
                class="url-input-narrow input_calendar"
                onchange="{ onDate }"
              />
            </div>

            <!--/.modal_input_box-->
            <div class="modal_input-dash">〜</div>
            <div class="modal_input_box">
              <label for="day_end">終了日</label>
              <input
                type="text"
                id="day_end"
                name="end_date"
                data="{ state.data }"
                is="binding"
                class="url-input-narrow input_calendar"
                onchange="{ onDate }"
              />
            </div>
            <!--/.modal_input_box-->
          </div>
          <!--/.modal_input_container-->

          <h3 class="modal_subtitle">文字重複チェックの結果条件</h3>
          <div class="modal_input_container">
            <div class="modal_input_box">
              <label for="txt_count">最高一致文字数</label>
              <input
                type="text"
                id="txt_count"
                name="min_length"
                is="binding"
                data="{ state.data }"
                class="url-input-narrow"
              />
            </div>
            <!--/.modal_input_box-->
            <div class="modal_input-txt">文字以上</div>
            <div class="modal_input_box">
              <label for="txt_percent">最高一致率</label>
              <input
                type="text"
                id="txt_percent"
                name="min_ratio"
                is="binding"
                data="{ state.data }"
                class="url-input-narrow"
              />
            </div>
            <!--/.modal_input_box-->
            <div class="modal_input-txt">%以上</div>
          </div>
          <!--/.modal_input_container-->

          <h3 class="modal_subtitle">類似度チェックの結果条件</h3>
          <div class="modal_input_container">
            <div class="modal_input_box">
              <label for="txt_similar">類似度</label>
              <input
                type="text"
                id="txt_similar"
                name="similarity"
                is="binding"
                data="{ state.data }"
                class="url-input-narrow"
              />
            </div>
            <!--/.modal_input_box-->
            <div class="modal_input-txt">/100以上</div>
          </div>
          <!--/.modal_input_container-->
        </form>
        <!--/.form_filter	-->

        <p class="notice" each="{ error in state.errors }">
          { labels[error.prop] }：{ error.error }
        </p>

        <button
          class="button button-primary"
          type="button"
          value="この条件で検索する"
          onclick="{ onConfirm }"
        >
          この条件で検索する
        </button>
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ onClose }">
        <img src="/assets/img/common/icn_close_modal.svg" alt="閉じる" />
      </a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->

  <script>
    import di from "dependeny-injection";
    import modalBase from "./modal-base.riot";
    import { SearchParam } from "@model/accept.js";

    export default {
      components: {
        "modal-base": modalBase,
      },
      state: {
        errors: {},
        data: new SearchParam(),
      },
      labels: {
        start_date: "開始日",
        end_date: "終了日",
        min_length: "最高一致文字数",
        min_ratio: "最高一致率",
        similarity: "類似度",
      },
      onMounted() {
        window.$(this.$("#day_start")).datepicker({
          onSelect: (selectedDate) => {
            this.state.data.start_date = this.$("#day_start").value;
            window
              .$(this.$("#day_end"))
              .datepicker("option", "minDate", selectedDate);
          },
        });
        window.$(this.$("#day_end")).datepicker({
          onSelect: (selectedDate) => {
            this.state.data.end_date = this.$("#day_end").value;
            window
              .$(this.$("#day_start"))
              .datepicker("option", "maxDate", selectedDate);
          },
        });
      },
      onDate(e) {
        this.state.data[e.target.name] = e.target.value;
      },
      onBeforeShow() {
        this.state.data = this.props.param.clone();
        this.state.errors = {};
        this.update();
      },
      onClose(e) {
        this.props.onClose ? this.props.onClose(e) : "";
      },
      onConfirm() {
        const errors = this.state.data.valid();
        this.update({ errors });
        if (errors.length == 0) {
          window.$(this.$(`#${this.props.modalId}`)).fadeOut(100);
          this.props.onConfirm(this.state.data);
        }
      },
    };
  </script>
</accept-modal>
